<template>
  <p class="control has-icons-left">
    <input
      v-model="value"
      :placeholder="placeholder"
      @keyup="search(value)"
      class="input is-rounded"
      type="text"
    />
    <span class="icon is-small is-left">
      <i class="fa fa-search"></i>
    </span>
  </p>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      value: ''
    }
  },

  computed: {
    placeholder() {
      if (this.$route.path === '/wishlist') {
        return 'Search in wishlist...'
      } else {
        return 'Search...'
      }
    }
  },

  methods: {
    search(value) {
      if (value.length > 0) {
        this.$store.commit('setHasUserSearched', true)
        this.$store.commit('setProductTitleSearched', value)
      } else {
        this.$store.commit('setHasUserSearched', false)
        this.$store.commit('setProductTitleSearched', '')
      }
    }
  }
}
</script>
